const getDictionaryType = (string) => {
  if (!string) {
    return [];
  } else {
    var dictionary = new Object();
    string.split(",").forEach((item) => {
      if (item) dictionary[item.toLowerCase()] = "true";
    });
    return dictionary;
  }
};

export default getDictionaryType;
